import * as React from 'react';

const getDefaultColumns = (data) => {
    if (data.length === 0) {
        return [];
    }
    return Object.keys(data[0]).reduce((prev, key) => {
        if (key === 'subRows') {
            return prev;
        }
        const column = {
            accessorKey: key,
            cell: (info) => React.createElement("span", null, info.getValue()),
            footer: (props) => props.column.id,
        };
        prev.push(column);
        return prev;
    }, []);
};

export { getDefaultColumns };
//# sourceMappingURL=getDefaultColumns.js.map
